import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BedSizeCategoriesComponent } from './bed-size-categories.component';

const bedSizeCategoriesRoutes: Routes = [
  { path: '', component: BedSizeCategoriesComponent, data: { title: 'Bed Size Categories' } }
];

@NgModule({
  imports: [RouterModule.forChild(bedSizeCategoriesRoutes)],
  exports: [RouterModule]
})
export class BedSizeCategoriesRouting {}



// WEBPACK FOOTER //
// ./src/app/t4-bed-size-categories/bed-size-categories-routing.module.ts